import './index.css'
import cn from 'clsx'

import React from 'react'
type Props = {
  children?: React.ReactNode
  fill?: string | null | undefined
  image?: string | null | undefined
  ratio: number
  shape?: 'circle' | 'square' | 'none'
  type?: 'shadow'
  fit?: 'cover' | 'contain' | 'fill' | 'none'
}

const AspectRatio = ({
  children,
  fill,
  image,
  ratio,
  shape = 'square',
  type,
  fit,
}: Props): React.ReactElement<'div'> => (
  <div
    className={cn('AspectRatio', {
      'AspectRatio--circle': shape === 'circle',
      'AspectRatio--square': shape === 'square',
      'AspectRatio--image': image,
      'AspectRatio--placeholder': !image,
      'AspectRatio--shadow': type === 'shadow',
      'AspectRatio--fit-cover': fit === 'cover',
      'AspectRatio--fit-contain': fit === 'contain',
      'AspectRatio--fit-fill': fit === 'fill',
      'AspectRatio--fit-none': fit === 'none',
    })}
    style={{
      backgroundColor: fill ?? undefined,
      backgroundImage: image ? `url("${image}")` : undefined,
      paddingBottom: (1 / ratio) * 100 + '%',
    }}
  >
    {children && <div className="AspectRatio-container">{children}</div>}
  </div>
)

export default AspectRatio
